import React from 'react';
import BaseTable from './BaseTable';
import MultiTableBody from './tbody/MultiAddTableBody';

interface Header {
  label: string;
  sortable: boolean;
  sortKey: string;
  width: string;
}

interface HasId {
  id: string;
}

/** 構造的Ref（非推奨型は使わない） */
type DivRef = { current: HTMLDivElement | null };

interface MultiAddTableProps<T extends HasId> {
  headers: ReadonlyArray<Header>;
  items: T[];
  addItem: (item: T) => React.JSX.Element;

  /** 親（画面）から表の横スクロール要素を参照するための ref */
  scrollContainerRef?: DivRef;
  headerRef?: React.RefObject<HTMLDivElement | null>; // 高さ計算用
  footerRef?: React.RefObject<HTMLDivElement | null>; // 高さ計算用
}

const MultiAddTable = <T extends HasId>({
  headers,
  items,
  addItem,
  scrollContainerRef,
  headerRef,
  footerRef,
}: MultiAddTableProps<T>) => {
  return (
    // 横スクロールはこのラッパのみ。ヘッダーは SyncedScrollHeader で追従させる。
    <div
      className="multi-add-table-scroll"
      style={{ overflowX: 'auto', maxWidth: '100%' }}
      ref={scrollContainerRef as unknown as React.Ref<HTMLDivElement>}
    >
      <BaseTable headers={headers} headerRef={headerRef} footerRef={footerRef}>
        <MultiTableBody<T> items={items} addItem={addItem} />
      </BaseTable>
    </div>
  );
};

export default MultiAddTable;
